import { ContentControlDataProtectionExclusion } from '@nirvana/shared/dtos/types/policies/common';
import { ContentControlDataProtectionExclusionFrontendFields } from '../GzContentControlDataProtectionExclusionsGridDataProvider';

export function getSanitizedItemWithoutAdditionalFrontendFields(
  gridItem: ContentControlDataProtectionExclusionFrontendFields
): ContentControlDataProtectionExclusion {
  const { rulesToConsiderString, ...sanitizedItem } = gridItem;

  return sanitizedItem;
}
